import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Dialog from '@magalu/stereo-ui/atoms/Dialog';
export var DialogContainer = styled(Dialog)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), function (_ref) {
  var position = _ref.position;
  return position === 'bottom' ? '100%' : '30%';
});